import { useLocation } from "react-router-dom";

const useUrlSearchAllParams = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  return Object.fromEntries(queryParams.entries());
};

export default useUrlSearchAllParams;
